export enum UserRole {
  Admin = 'ROLE_ADMIN',
  CircleAdmin = 'ROLE_CIRCLE_ADMIN',
  User = 'ROLE_USER',
  ClientAdmin = 'ROLE_CLIENT_ADMIN',
}
